module.exports = __webpack_public_path__ + "static/splash-events-2021-b9f6ec999efd6a078c32034b7a0fa8cb.jpg";